// src/theme.js
import { createTheme } from "@mui/material/styles";
import { colorSwitcherTwo } from "../constants/styleConstant";

const theme = createTheme({
  palette: {
    mode: "light", // or 'dark'
  },
  typography: {
    fontFamily: [
      "Inter", // ✅ professional font
      "Roboto",
      "Segoe UI",
      "Helvetica Neue",
      "Arial",
      "sans-serif",
    ].join(","),
    fontSize: 14, // global base size
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: "Inter, Roboto, Segoe UI, Helvetica Neue, Arial, sans-serif!important",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: "1em",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: colorSwitcherTwo,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colorSwitcherTwo,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#595959", // default
          fontFamily: [
            "Inter", // ✅ professional font
            "Roboto",
            "Segoe UI",
            "Helvetica Neue",
            "Arial",
            "sans-serif",
          ].join(","),
          fontSize: "1em",
          "&.Mui-focused": {
            color: colorSwitcherTwo, // ✅ shrink/focus color
          },
          "&.Mui-disabled": {
            color: colorSwitcherTwo, // ✅ disabled label color
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: "36px", // Makes the tab bar thinner to match small font
        },
        indicator: {
          backgroundColor: colorSwitcherTwo, // Global indicator color
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: ".95em", // ✅ Global Font Size
          textTransform: "none", // ✅ Stops ALL CAPS
          minHeight: "36px",
          minWidth: "70px",
          padding: "6px 12px",
          color: "#666",
          "&.Mui-selected": {
            color: colorSwitcherTwo, // ✅ Active text color
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            backgroundColor: "#f5f5f5", // The background color you want
            color: "#000", // The text color you want
            opacity: 1,
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            opacity: 1, // ✅ This removes the 0.38 fading effect
          },
        },
        content: {
          "&.Mui-disabled": {
            // You can also ensure the inner content stays visible
            margin: "12px 0",
          },
        },
      },
    },
  },
});

export default theme;
